import { useState, type FormEvent } from 'react';
import { adminApi, ApiError } from './admin-api.ts';
import { AdminShell, Card, PrimaryButton, TextField } from './ui.tsx';

// Named-account login (email + password).
export function AdminLogin({ onSuccess }: { onSuccess: () => void }) {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  const submit = async (e: FormEvent) => {
    e.preventDefault();
    setBusy(true);
    setError(null);
    try {
      await adminApi.login(email, password);
      onSuccess();
    } catch (err) {
      setError(
        err instanceof ApiError && err.status === 401
          ? 'Invalid email or password.'
          : 'Sign-in failed. Please try again.',
      );
    } finally {
      setBusy(false);
    }
  };

  return (
    <AdminShell>
      <div className="mx-auto mt-10 w-full max-w-sm">
        <Card>
          <h1 className="text-xl font-semibold text-ink">Administrator sign-in</h1>
          <p className="mt-1 text-sm text-ink-soft">Enter your email and password.</p>
          <form className="mt-6 flex flex-col gap-4" onSubmit={submit}>
            <TextField
              id="admin-email"
              label="Email"
              type="email"
              value={email}
              onChange={setEmail}
              autoComplete="username"
              required
            />
            <TextField
              id="admin-password"
              label="Password"
              type="password"
              value={password}
              onChange={setPassword}
              autoComplete="current-password"
              required
            />
            {error && (
              <p className="text-sm text-red-600" role="alert">{error}</p>
            )}
            <PrimaryButton type="submit" disabled={busy}>
              {busy ? 'Signing in…' : 'Sign in'}
            </PrimaryButton>
          </form>
        </Card>
      </div>
    </AdminShell>
  );
}
